import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { PointOfContactChangeForm } from './PointOfContactChangeForm'

/**
 * @privateRemarks
 * TODO: Camilla or someoneelse needs to check up on this
 */
export function PointOfContactChangeCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, legalEntityId } = useHook(
    'routing.general.useLegalEntityParams',
  )()
  const actions = useHook('mutators.crm.usePointOfContactActions')({
    personId: legalEntityId,
    tenantId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.PointOfContactChangeCommandData"
      title={translate('pointOfContact.button')}
      commandDataForm={PointOfContactChangeForm}
      {...props}
      submit={submit}
    />
  )
}
